import { render, staticRenderFns } from "./leaveDetail.vue?vue&type=template&id=2e76e846&scoped=true"
import script from "./leaveDetail.vue?vue&type=script&lang=js"
export * from "./leaveDetail.vue?vue&type=script&lang=js"
import style0 from "./leaveDetail.vue?vue&type=style&index=0&id=2e76e846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e76e846",
  null
  
)

export default component.exports